import ItemModel from '../models/item';
import LocationItemModel from '../models/location-item';

export default function amountName(
  locationItemOrItem: ItemModel | LocationItemModel,
  amount: number /* named*/
) {
  // If locationItemOrItem is an Item, we can use it directly
  let item: ItemModel;
  if (locationItemOrItem instanceof ItemModel) {
    item = locationItemOrItem;
  } else if (locationItemOrItem instanceof LocationItemModel) {
    item = locationItemOrItem.item;
  } else {
    throw new Error(
      'Invalid argument: expected ItemModel or LocationItemModel'
    );
  }
  if (item.container_size === 1) {
    if (item.single_size > 5000) {
      return amount === 1 ? 'Fass' : 'Fässer';
    } else {
      return amount === 1 ? 'Flasche' : 'Flaschen';
    }
  } else {
    return 'Gebinde';
  }
}
